import { CircularLoader } from '@modules/common/components/CircularLoader';
import { useGetDefaultTenantTimeRange } from '@modules/common/hooks';
import { useUpdateStoreForNewQuantifyAnalysis } from '@modules/quantify/hooks';
import { useQuantifySessionStorage } from '@modules/quantify/hooks/useQuantifySessionStorage';
import { QuantifyActionType } from '@modules/quantify/store/quantifyActionType';
import { quantifyInitialState } from '@modules/quantify/store/quantifyInitialState';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { getQuantifyQueryRetentionKey } from '@modules/quantify/utils';
import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useGetUser } from 'v2/core/services/user';
import { QuantifyAnalysis } from '../QuantifyAnalysis/QuantifyAnalysis';

export function NewQuantifyAnalysis() {
  const {
    tenant: { slug: tenantSlug },
  } = useGetUser();

  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useQuantifyStore(({ dispatch }) => dispatch);
  const { setSessionStorageFromQuantifyStore } = useQuantifySessionStorage();

  const { isLoading, isDataSetupDone } = useUpdateStoreForNewQuantifyAnalysis();

  const resetSearchParam = searchParams.get('reset');

  const defaultTimeRange = useGetDefaultTenantTimeRange();

  useEffect(() => {
    quantifyInitialState.query.duration = defaultTimeRange;
  }, [defaultTimeRange]);

  useEffect(() => {
    if (resetSearchParam === 'true') {
      sessionStorage.removeItem(getQuantifyQueryRetentionKey(tenantSlug));
      dispatch({
        type: QuantifyActionType.RESET_QUERY,
      });
      setSearchParams({});
    }
  }, [dispatch, resetSearchParam, setSearchParams, tenantSlug]);

  useEffect(() => {
    // Only start persisting if data setup is complete
    if (!isDataSetupDone) {
      return;
    }

    return () => {
      setSessionStorageFromQuantifyStore();
    };
  }, [isDataSetupDone, setSessionStorageFromQuantifyStore]);

  if (isLoading || !isDataSetupDone) {
    return (
      <Box height="100vh">
        <CircularLoader />
      </Box>
    );
  }

  return <QuantifyAnalysis />;
}
